import { render } from "./PatientBillingHistory.vue?vue&type=template&id=84baa99c"
import script from "./PatientBillingHistory.vue?vue&type=script&lang=js"
export * from "./PatientBillingHistory.vue?vue&type=script&lang=js"

import "./PatientBillingHistory.vue?vue&type=style&index=0&id=84baa99c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/PatientBillingHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84baa99c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84baa99c', __exports__)) {
    console.log('reload')
    api.reload('84baa99c', __exports__)
  }
  
  module.hot.accept("./PatientBillingHistory.vue?vue&type=template&id=84baa99c", () => {
    console.log('re-render')
    api.rerender('84baa99c', render)
  })

}


export default __exports__